/**
 * Productos asignados en algún hueco de la estación que no llegan al mínimo de huecos.
 * Devuelve un objeto { productId: huecosAsignados }.
 */
export const getUnderAssignedProducts = (phus, minSlots) => {
    const counters = phus.reduce((acc, phu) => {
        phu.slots.forEach((slot) => {
            if (slot.product_id) {
                acc[slot.product_id] = (acc[slot.product_id] || 0) + 1
            }
        })
        return acc
    }, {})

    return Object.keys(counters).reduce((acc, productId) => {
        if (counters[productId] < minSlots) {
            acc[productId] = counters[productId]
        }
        return acc
    }, {})
}
